import React, { Component } from 'react';
import { Button, Card, Form, Table } from 'antd';
import moment from 'moment';
import { queryCustomList } from '@api/crm/crm';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
      total: 0,
      pageNo: 1,
    };
  }

  componentDidMount() {
    this.loadData(1);
  }

  loadData = (pageNo, condition) => {
    const params = {};
    const context = this;
    const no = this.state.pageNo;
    const current = pageNo || no;
    params.limit = 15;
    params.start = current;
    params.condition = condition || '';
    this.setState({
      pageNo,
    });
    queryCustomList(params).then(res => {
      if (res.statusCode === 200) {
        context.setState({
          data: res.data,
          total: res.totalSize,
          isLoading: false,
          currentTotal: res.data.currentTotal,
        });
      }
    });
  };

  columns = () => [
    {
      title: '更新时间',
      dataIndex: 'updateTime',
      render: text => {
        return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
      },
    },
    {
      title: '内容',
      dataIndex: 'uuid',
      render: (text, record, index) => {
        return <span>{index + 1}</span>;
      },
    },
    {
      title: '来源',
      dataIndex: 'name',
      render: text => {
        return <a onClick={this.showDrawer}>{text}</a>;
      },
    },
  ];

  render() {
    const { data, total } = this.state;
    const pagination = {
      showSizeChanger: false,
      pageSize: 15,
      total,
      current: this.state.pageNo,
      onChange: current => {
        this.loadData(current);
      },
      showTotal: showTotal => {
        return `共 ${showTotal} 条`;
      },
    };
    return (
      <Card>
        <div className="tableList">
          <div className="tableListOperator">
            <Button>添加记录</Button>
          </div>
        </div>
        <Table
          rowKey="uuid"
          size="small"
          columns={this.columns()}
          dataSource={data}
          pagination={pagination}
        />
      </Card>
    );
  }
}
export default Form.create({ wrappedComponentRef: true })(Index);



// WEBPACK FOOTER //
// ./src/components/client/manage/TabHistory.js